import axiosBase from 'axios';

const axios = axiosBase.create({
    baseURL: 'http://p1581.cupivan.ru:5555/',
    timeout: 15000,
    crossDomain: true,
});

export const getAllPoints = () => {
    return new Promise((res) => {
        setTimeout(() => {
            res({
                data: [],
                status: 200,
            });
        }, 1500);
    });
    return axios.get('/points');
};
